import { createI18n } from 'vue-i18n';
import { setupAxiosInterceptors } from '@/shared/config/axios-interceptor';
import { initFilters } from '@/shared/date/filters';
import type { App } from 'vue';

export function initVueApp(app: App): void {
  setupAxiosInterceptors(() => {
    console.log('Unauthorized!');
  });
  initFilters(app);
}

export function initI18N() {
  return createI18n({
    legacy: false,
    globalInjection: true,
    dateTimeFormats: {
      pl: {
        short: {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
        },
        medium: {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          weekday: 'short',
          hour: 'numeric',
          minute: 'numeric',
        },
        long: {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          weekday: 'long',
          hour: 'numeric',
          minute: 'numeric',
        },
      },
      en: {
        short: {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
        },
        medium: {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          weekday: 'short',
          hour: 'numeric',
          minute: 'numeric',
        },
        long: {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          weekday: 'long',
          hour: 'numeric',
          minute: 'numeric',
        },
      },
      fr: {
        short: {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
        },
        medium: {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          weekday: 'short',
          hour: 'numeric',
          minute: 'numeric',
        },
        long: {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          weekday: 'long',
          hour: 'numeric',
          minute: 'numeric',
        },
      },
    },
    missingWarn: false,
    fallbackWarn: false,
  });
}
